/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AvatarMenu } from "@farmlands/shadcn-ui";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import TestIds from "../../../../testIds";
import { selectIsThisTfo, selectUserContactDetails } from "../../../azure-b2c/storage";
import AccountMenu from "../../components/AccountMenu/AccountMenu";
import SelectedAccount from "../../components/SelectedAccount/SelectedAccount";

const NavbarAccountMenu: FC = () => {
  const userDetails = useSelector(selectUserContactDetails);
  const isTfo = useSelector(selectIsThisTfo);
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <div
      className="flex flex-row items-center gap-4"
      data-testid={TestIds.feat.account.navbarAccountMenu.component}
    >
      <SelectedAccount enableAccountSwitcher variant="inverse" truncateAccountName />

      <AvatarMenu
        name={[userDetails?.firstName, userDetails?.lastName].filter(Boolean).join(" ")}
        open={open}
        onOpenChange={setOpen}
        avatarButtonProps={{
          "aria-label": "Open the account menu",
          "data-testid": TestIds.feat.account.userAccount.initialsCircle.button,
          className:
            "size-11 bg-white! after:ring-white! focus-visible:after:ring-[0.1875rem]! hover:bg-forest-green-50! active:bg-forest-green-100!",
        }}
        menuContentProps={{
          align: "end",
          sideOffset: 16,
          className: "w-[23.4rem] max-h-[calc(100vh-6rem)] overflow-auto rounded-lg p-0",
          "data-testid": TestIds.feat.account.navbarAccountMenu.popper,
        }}
      >
        <AccountMenu
          enableLogout
          enableAccountDetails
          enableQuotes
          enableOrders
          enableCards
          enablePayments
          enableStatements
          enableActivities={isTfo}
        />
      </AvatarMenu>
    </div>
  );
};

export default NavbarAccountMenu;
